<div class="content-grid-wrapper h-full">
  <div class="col-span-10">
    <app-content-header
      [title]="dashboardHeaderTitle"
      titleClass="text-primaryText"
      [description]="'WM.DASHBOARD.TITLE' | translate"
    ></app-content-header>
  </div>

  <div class="col-span-10 flex flex-col gap-(--spacing-layout-l)">
    <app-pill-tabs
      [tabs]="dashboardTabs"
      [activeIndex]="activeTabIndex()"
      (activeTabChange)="onTabChange($event)"
    />

    @switch (activeTabIndex()) {
      @case (0) {
        @defer (on immediate) {
          <app-wm-summary
            [hideTotalClients]="isWmUsers() || isWmDeals()"
            [hideTotalRms]="isWmDeals()"
            [hideWealthManagersOnboard]="isWmUsers() || isWmDeals() || isWmSuperUser()"
            [hideUserType]="isWmDeals() || isWmUsers() || isWmSuperUser()"
          />
        }
      }
      @case (1) {
        @defer (on immediate) {
          <app-wm-rm-clients />
        }
      }
      @case (2) {
        @defer (on immediate) {
          <app-wm-deals />
        }
      }
      <!-- @case (3) {
        @defer (on immediate) {
          <app-wm-personalized-dashboard />
        }
      } -->
    }
  </div>
</div>

<!-- legacy code
<div class="content-grid-wrapper h-full">
  <div class="col-span-10">
    <app-content-header [title]="dashboardHeaderTitle" titleClass="text-primaryText"
      [description]="'WM.DASHBOARD.TITLE' | translate"></app-content-header>
  </div>

  <div class="col-span-10 grid grid-cols-12 gap-(--spacing-layout-l)">
    <div class="col-span-12 flex justify-end items-center">
      <div class="min-w-[220px]">
    @if(filterPeriodValueReady()){
        <app-select [value]="filterPeriodValue" [options]="filterPeriodValues" optionLabel="label" optionValue="value"
          (onChange)="onSelectFilterPeriodValue($event)" [fluid]="true" />
        }
      </div>
    </div>
    <app-wm-stats-widget
      class="contents"
      [hideTotalClients]="isWmUsers() || isWmDeals()"
      [hideTotalRms]="isWmDeals()"
      [xlColSpan]="isWmDeals() ? 6 : (isWmUsers() ? 4 : 3)"
    />
    <div class="col-span-12 xl:col-span-6">
      <app-card>
        <div class="flex flex-col">
          <div class="text-subheading-large text-headingText p-5 pt-4 ">Investments</div>
          <div class="p-5">
            @if (trendState().loading && !trendState().data) {
              <div class="flex items-center justify-between gap-3 h-[200px]">
                <p-skeleton height="100%" width="1.5rem" />
                <p-skeleton height="100%" width="1.5rem" />
                <p-skeleton height="100%" width="1.5rem" />
                <p-skeleton height="100%" width="1.5rem" />
                <p-skeleton height="100%" width="1.5rem" />
                <p-skeleton height="100%" width="1.5rem" />
                <p-skeleton height="100%" width="1.5rem" />
              </div>
            } @else if (trendState().error) {
            <div class="flex items-center justify-center min-h-[200px] text-bodyText">Failed to load investments trend.</div>
            } @else if (!trendState().data?.series?.length || !trendState().data?.categories?.length) {
            <div class="flex items-center justify-center min-h-[200px] text-bodyText">No data available</div>
            } @else {
            <app-line-chart [lineData]="lineData"></app-line-chart>
            }
          </div>
        </div>
      </app-card>
    </div>
    <div class="col-span-12 xl:col-span-6">
      <app-revenue-stream-widget />
    </div>

    <div class="col-span-12 xl:col-span-6">
      @if (volumeByAssetClassState().loading && !volumeByAssetClassState().data) {
        <app-card class="h-full" rootClass="h-full" bodyClass="h-full" contentClass="h-full">
        <div class="flex justify-between gap-3 w-full h-full min-h-[200px] p-5">
          <div class="flex-1">
            <div class=" flex-1 flex flex-col gap-2">
              <p-skeleton height="1rem" width="100%" />
              <p-skeleton height="1rem" width="100%" />
              <p-skeleton height="1rem" width="100%" />
              <p-skeleton height="1rem" width="100%" />
              <p-skeleton height="1rem" width="100%" />
              <p-skeleton height="1rem" width="100%" />
            </div>
          </div>
          <div class=" flex-1 flex flex-col gap-2">
            <p-skeleton height="1rem" width="100%" />
            <p-skeleton height="1rem" width="100%" />
            <p-skeleton height="1rem" width="100%" />
            <p-skeleton height="1rem" width="100%" />
            <p-skeleton height="1rem" width="100%" />
            <p-skeleton height="1rem" width="100%" />
          </div>
        </div>
        </app-card>
      } @else if (volumeByAssetClassState().error) {
        <app-card class="h-full" rootClass="h-full" bodyClass="h-full" contentClass="h-full">
          <div class="flex items-center justify-center h-full text-bodyText">Failed to load volume by asset class.</div>
        </app-card>
      } @else {
      <app-best-selling-widget
        [title]="volumeByAssetClassState().data?.title ?? 'Total Investment Volume'"
        [items]="(volumeByAssetClassState().data?.items ?? []).map(i => ({ label: i.label, icon: volumeByAssetClassIconByKey(i.key), percentage: i.percentage }))"
      />
      }
    </div>


    @if (!(isWmUsers() || isWmDeals() || isWmSuperUser())) {
    <div class="col-span-12 xl:col-span-6">
      <app-card>
        <div class="flex flex-col">
          <div class="text-subheading-large text-headingText p-5 pt-4 ">Wealth Managers Onboard status</div>
          <div class="p-5">
            @if (!doughnutChartData || !doughnutChartData.datasets || doughnutChartData.datasets.length === 0) {
            <div class="flex items-center justify-center min-h-[200px] text-bodyText">No data available</div>
            } @else {
            <app-doughnut-chart [data]="doughnutChartData"></app-doughnut-chart>
            }
          </div>
        </div>
      </app-card>
    </div>
    }
    
    @if (!(isWmDeals() || isWmUsers() || isWmSuperUser())) {
    <div class="col-span-12" [class.xl:col-span-6]="!isWmUsers()" [class.xl:col-span-4]="isWmUsers()">

      <app-card class="h-full" rootClass="h-full" bodyClass="h-full" contentClass="h-full">
        <div class="flex flex-col">
          <div class="text-subheading-large text-headingText p-5 pt-4 ">
            User type
          </div>
          <div class="p-5">
            @if (!barData) {
            <div class="flex items-center justify-between gap-3 h-[200px]">
              <p-skeleton height="100%" width="1.5rem" />
              <p-skeleton height="100%" width="1.5rem" />
              <p-skeleton height="100%" width="1.5rem" />
              <p-skeleton height="100%" width="1.5rem" />
              <p-skeleton height="100%" width="1.5rem" />
              <p-skeleton height="100%" width="1.5rem" />
              <p-skeleton height="100%" width="1.5rem" />
            </div>
            } @else {
            <app-bar-chart [barChartData]="barData"></app-bar-chart>
            }
          </div>
        </div>
      </app-card>
    </div>
    }



    <div class="col-span-12 xl:col-span-6">
      <app-notifications-widget />
    </div>
  </div>
</div>
-->
